// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"587ed204","453":"8db25e3c","455":"3d2f4ad9"}[chunkId] + ".chunk.js";
};